"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLookupValueSchema = exports.createLookupValueSchema = exports.lookupValueShape = exports.updateLookupTypeSchema = exports.createLookupTypeSchema = exports.lookupTypeShape = exports.masterDataDomainEnum = void 0;
const zod_1 = require("zod");
exports.masterDataDomainEnum = zod_1.z.enum([
    'GEOGRAPHY',
    'PATIENT',
    'CLINICAL',
    'HOSPITAL',
    'LABORATORY',
    'RADIOLOGY',
    'PHARMACY',
    'INVENTORY',
    'FINANCE',
    'HR',
    'COMMUNICATION',
    'SYSTEM',
]);
exports.lookupTypeShape = {
    domain: exports.masterDataDomainEnum,
    code: zod_1.z
        .string()
        .min(1)
        .max(50)
        .regex(/^[A-Z][A-Z0-9_]*$/, 'Lookup type code must be SCREAMING_SNAKE_CASE'),
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().optional(),
};
exports.createLookupTypeSchema = zod_1.z.object(exports.lookupTypeShape);
exports.updateLookupTypeSchema = zod_1.z.object({
    name: exports.lookupTypeShape.name.optional(),
    description: exports.lookupTypeShape.description,
});
exports.lookupValueShape = {
    lookupTypeId: zod_1.z.string().uuid(),
    parentValueId: zod_1.z.string().uuid().optional(),
    code: zod_1.z
        .string()
        .min(1)
        .max(50)
        .regex(/^[A-Z][A-Z0-9_]*$/, 'Lookup value code must be SCREAMING_SNAKE_CASE'),
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().optional(),
    sortOrder: zod_1.z.number().int().default(0),
};
exports.createLookupValueSchema = zod_1.z.object(exports.lookupValueShape);
exports.updateLookupValueSchema = zod_1.z.object({
    name: exports.lookupValueShape.name.optional(),
    description: exports.lookupValueShape.description,
    sortOrder: exports.lookupValueShape.sortOrder.optional(),
    parentValueId: exports.lookupValueShape.parentValueId,
});
//# sourceMappingURL=lookup.schema.js.map